import { defineMessages } from 'react-intl';

export default defineMessages({
  new: {
    id: 'bitkit.navigation.containerNavigation.new',
    description: 'Text for new lozenge',
    defaultMessage: 'New',
  },
});
